<template>
  <div class="teach">
    <div v-if="pageType == 1">
      <div class="line" style="padding-top: 20px">
        <el-input
          class="search-input"
          v-model="searchCourseId"
          placeholder="输入课程ID"
          clearable
        ></el-input>
        <el-input
          class="search-input"
          v-model="searchCourseName"
          placeholder="输入课程标题"
          clearable
        ></el-input>
        <el-button class="search-button" type="primary" @click="search()"
          >查询</el-button
        >
      </div>
      <!-- 课程列表 -->
      <el-table
        class="data-table"
        :data="courseData"
        v-loading="loading"
        height="calc(100vh - 260px)"
      >
        <el-table-column
          align="center"
          prop="id"
          label="ID"
          width="50"
        ></el-table-column>
        <el-table-column align="center" label="课程信息" min-width="400">
          <template slot-scope="scope">
            <div style="display: flex; justify-content: center">
              <img
                :src="scope.row.cover"
                alt=""
                style="width: 140px; height: 80px"
              />
              <div style="margin-left: 10px; text-align: left">
                <div class="userInfo">{{ scope.row.course_name }}</div>
                <div class="userInfo">
                  课件数量：{{ scope.row.courseware_count }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="grade"
          label="年级"
          min-width="100"
        >
          <template slot-scope="scope">
            <div>
              {{ gradeData[scope.row.grade] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="attend_count"
          label="上课次数"
          min-width="100"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.attend_count || 0 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="收藏" min-width="100">
          <template slot-scope="scope">
            <div>
              <el-switch
                :value="scope.row.collect_count == 1"
                active-color="#13ce66"
                inactive-color="#EAECF0"
                @change="collectCourse(scope.row)"
              >
              </el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="400">
          <template slot-scope="scope">
            <div>
              <el-button type="primary" size="mini" @click="toClass(scope.row)"
                >上课</el-button
              >
              <el-button
                v-if="webType == 1"
                type="primary"
                size="mini"
                @click="toQuestions(scope.row)"
                >提问管理</el-button
              >
              <el-button type="primary" size="mini" @click="toRecord(scope.row)"
                >教学日志</el-button
              >
              <el-button
                v-if="webType == 1"
                type="primary"
                size="mini"
                @click="toEvaluate(scope.row)"
                >期末评价</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageChange"
        :current-page="coursePage"
        background
        layout="prev, pager, next, total, jumper"
        :total="courseTotal"
      ></el-pagination>
    </div>

    <div v-if="pageType == 2">
      <!-- 教学日志 -->
      <el-page-header
        @back="goBack"
        content="教学日志"
        style="padding-top: 10px"
      >
      </el-page-header>
      <div class="line" style="padding-top: 20px; justify-content: flex-end">
        <el-button type="primary" @click="addRecord">新建日志</el-button>
      </div>
      <!-- 教学日志列表 -->
      <el-table
        :data="recordData"
        v-loading="loading"
        height="calc(100vh - 300px)"
      >
        <el-table-column
          align="center"
          prop="id"
          label="ID"
          width="50"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="title"
          label="日志标题"
          min-width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="courseware_title"
          label="对应课件名称"
          min-width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="created_at"
          label="创建日期"
          min-width="100"
        ></el-table-column>
        <el-table-column align="center" label="操作" min-width="100">
          <template slot-scope="scope">
            <div>
              <el-button
                type="primary"
                size="mini"
                @click="editRecord(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="deleteRecord(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageChange"
        :current-page="recordPage"
        :page-size="20"
        background
        layout="prev, pager, next, total, jumper"
        :total="recordTotal"
      ></el-pagination>
    </div>
    <!-- 教学日志详情 -->
    <el-dialog
      :title="form.id ? '编辑教学日志' : '新建教学日志'"
      :visible.sync="recordDetail"
      width="60%"
    >
      <div>
        <el-form ref="form" id="form" :model="form" label-width="150px">
          <el-form-item label="对应课件：">
            <el-select
              v-model="form.courseware_id"
              placeholder="请选择"
              :disabled="!!form.id"
            >
              <el-option
                v-for="item in recordCourseware"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日志标题：">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="日志内容：">
            <el-input type="textarea" v-model="form.content"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordDetail = false">取 消</el-button>
        <el-button type="primary" @click="submitRecord">确 定</el-button>
      </span>
    </el-dialog>

    <div v-if="pageType == 3">
      <!-- 期末评价 -->
      <el-page-header
        @back="goBack"
        content="期末评价"
        style="padding-top: 10px"
      >
      </el-page-header>
      <div class="line" style="padding-top: 20px; justify-content: flex-end">
        <el-button type="primary" @click="addEvaluate">新建评价</el-button>
      </div>
      <el-table
        :data="evaluateData"
        v-loading="loading"
        height="calc(100vh - 300px)"
      >
        <el-table-column
          align="center"
          prop="id"
          label="ID"
          width="50"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="title"
          label="期末测评标题"
          min-width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="created_at"
          label="创建日期"
          min-width="100"
        ></el-table-column>
        <el-table-column align="center" label="操作" min-width="100">
          <template slot-scope="scope">
            <div>
              <el-button
                type="primary"
                size="mini"
                @click="editEvaluate(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="eleteEvaluate(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageChange"
        :current-page="evaluatePage"
        :page-size="20"
        background
        layout="prev, pager, next, total, jumper"
        :total="evaluateTotal"
      ></el-pagination>
    </div>
    <!-- 期末评价详情 -->
    <el-dialog
      :title="form.id ? '编辑期末评价' : '新建期末评价'"
      :visible.sync="evaluateDetail"
      width="60%"
    >
      <!-- <div style="max-height: calc(100vh - 350px); overflow: auto"> -->
      <div>
        <el-form ref="form" id="form" :model="form" label-width="150px">
          <el-form-item label="期末评价标题：">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="期末评价内容：">
            <div style="position: relative">
              <el-input type="textarea" v-model="form.content"></el-input>
              <div class="abs" style="position: absolute; color: red">
                提示：根据需要选择是否上传图片或视频
              </div>
              <div style="height: 20px"></div>
            </div>
          </el-form-item>
          <!-- <el-form-item label=" ">
            <span style="color: red">提示：根据需要选择是否上传图片或视频</span>
          </el-form-item> -->
          <el-form-item label="图片内容：">
            <div>
              <div style="position: relative; width: 400px">
                <el-button type="primary">点击上传</el-button>
                <input
                  class="hidden-input"
                  type="file"
                  accept="image/*"
                  @change="uploadImgsNew"
                  ref="upload1"
                />
                <span style="color: red; margin-left: 16px"
                  >请上传10M以内的图片，支持png、jpg格式</span
                >
              </div>
              <!-- <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                accept=".jpg,.jpeg,.png"
                multiple
                :limit="5"
                :on-success="uploadImgs"
                :on-remove="removeImgs"
                :file-list="evaluateImgFiles"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload> -->
              <div class="file-list">
                <div
                  class="file-item"
                  v-for="(item, index) in evaluateImgFiles"
                  :key="item.id"
                  @mouseover="selectImg(index)"
                >
                  <img
                    class="file"
                    :src="item.url || item.raw.lastModifiedDate"
                    alt=""
                  />
                  <div
                    v-if="index == evaluateImgDelectIndex"
                    class="file-mask"
                    @click="delectImg(index)"
                  >
                    <i class="el-icon-delete file-delete"></i>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="视频内容：">
            <div>
              <div style="position: relative; width: 400px">
                <el-button type="primary">点击上传</el-button>
                <input
                  class="hidden-input"
                  type="file"
                  accept="video/*"
                  @change="uploadVideosNew"
                  ref="upload2"
                />
                <span style="color: red; margin-left: 16px"
                  >请上传200M以内的视频，支持MP4格式</span
                >
              </div>
              <!-- <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                accept=".mp4"
                multiple
                :limit="5"
                :on-success="uploadVideos"
                :on-remove="removeVideos"
                :file-list="evaluateVideoFiles"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload> -->
              <div class="file-list">
                <div
                  class="file-item"
                  v-for="(item, index) in evaluateVideoFiles"
                  :key="item.id"
                  @mouseover="selectVideo(index)"
                >
                  <video class="file" :src="item.url" alt=""></video>
                  <div
                    v-if="index == evaluateVideoDelectIndex"
                    class="file-mask"
                    @click="delectVideo(index)"
                  >
                    <i class="el-icon-delete file-delete"></i>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="evaluateDetail = false">取 消</el-button>
        <el-button type="primary" @click="submitEvaluate">确 定</el-button>
      </span>
    </el-dialog>

    <div v-if="pageType == 4">
      <!-- 提问管理 -->
      <el-page-header
        @back="goBack"
        content="提问管理"
        style="padding-top: 10px"
      >
      </el-page-header>
      <div class="line" style="padding-top: 20px">
        <el-input
          class="search-input"
          v-model="questionCoursewareName"
          placeholder="输入课程标题"
          clearable
        ></el-input>
        <el-select
          class="search-select"
          v-model="questionStatus"
          placeholder="回复状态"
          clearable
        >
          <el-option label="已回复" value="1"></el-option>
          <el-option label="未回复" value="2"></el-option>
        </el-select>
        <el-button class="search-button" type="primary" @click="search()"
          >查询</el-button
        >
      </div>
      <el-table
        :data="questionsData"
        v-loading="loading"
        height="calc(100vh - 300px)"
      >
        <el-table-column
          align="center"
          prop="id"
          label="ID"
          width="50"
        ></el-table-column>
        <el-table-column align="center" label="提问学生" min-width="150">
          <template slot-scope="scope">
            <div class="flex">
              <img class="avatar" :src="scope.row.stuImg" alt="" />
              <div style="width: 100%">
                <div class="">{{ scope.row.nick_name }}</div>
                <div class="">{{ scope.row.stuClass }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="course_period_name"
          label="课程/课件标题"
          min-width="150"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="question"
          label="问题"
          min-width="150"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="reply"
          label="回复"
          min-width="200"
        >
          <template slot-scope="scope">
            <div class="question-reply">{{ scope.row.reply }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" min-width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.reply ? '已回复' : '未回复' }}</div>
            <div>{{ scope.row.reply ? scope.row.reply_at : '' }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="100">
          <template slot-scope="scope">
            <div>
              <el-button
                type="primary"
                size="mini"
                @click="toShowQuestionDetail(scope.row)"
              >
                {{ scope.row.reply ? '编辑' : '回复' }}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageChange"
        :current-page="questionsPage"
        :page-size="20"
        background
        layout="prev, pager, next, total, jumper"
        :total="questionsTotal"
      ></el-pagination>
    </div>
    <!-- 提问管理详情 -->
    <el-dialog
      title="回复/编辑回复"
      :visible.sync="questionsDetail"
      width="60%"
    >
      <div>
        <el-form :model="form" label-width="150px">
          <el-form-item label="学生提问：">
            <div class="">{{ form.question }}</div>
          </el-form-item>
          <el-form-item label="老师回复：">
            <el-input type="textarea" v-model="form.reply"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="questionsDetail = false">取 消</el-button>
        <el-button type="primary" @click="submitQuestion">确 定</el-button>
      </span>
    </el-dialog>

    <div v-if="pageType == 5">
      <!-- 上课 -->
      <el-page-header @back="goBack" content="上课" style="padding-top: 10px">
      </el-page-header>
      <div class="phone">
        <div class="course-info">
          <img class="course-avatar" :src="courseInfo.cover" alt="" />
          <div>
            <div class="course-name">《{{ courseInfo.course_name }}》</div>
            <!-- <div class="course-grade">{{ courseInfo.grade }}</div> -->
            <div class="course-grade">{{ gradeData[courseInfo.grade] }}</div>
            <div class="course-num">
              课时/课件数量：{{ courseInfo.classHourNum }}/{{
                courseInfo.coursewareNum
              }}
            </div>
          </div>
        </div>
        <div class="course-list">
          <div class="course-catalogue">课程目录</div>
          <div v-for="item in courseware" :key="item.id">
            <div class="course-line"></div>
            <div class="course-title">{{ item.name }}</div>
            <div
              class="course-courseware"
              v-for="i in item.courseware"
              :key="i.id"
            >
              <div class="course-courseware-name">{{ i.title }}</div>
              <div>
                <el-button type="primary" size="mini" @click="toCourseware(i)"
                  >播放课件</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="pageType == 6" class="full">
      <video
        v-if="coursewareQACur.question_type == '视频'"
        class="video"
        :src="coursewareQACur.video_url"
        controls
        autoplay
      ></video>
      <!-- :src="coursewareQACur.video_url" -->
      <!-- src="https://file.mashu.cloud/xiaofenghuang/manageMaterial/video/16611520993671zgnhss.mp4" -->

      <div
        v-if="
          coursewareQACur.question_type == '选择题' ||
          coursewareQACur.question_type == '问答题'
        "
        class="QA-bg"
      >
        <div class="QA-content">
          <div class="QA-q">
            <!-- {{ coursewareQAIndex + 1 }}.{{ coursewareQACur.question }} -->
            {{ coursewareQACur.question }}
            <!-- 1.佤族主要生活在哪些地方啊？佤族主要生活在哪些地方啊？佤族主要生活在哪些地方啊？佤族主要生活在哪些地方啊？ -->
          </div>
          <div class="QA-a">
            <img
              class="QA-a-icon"
              src="../../images/answerIcon.png"
              alt=""
              srcset=""
              @click="toShowAnswer"
            />
            <div
              v-if="coursewareQACur.question_type == '问答题'"
              class="QA-a-content"
            >
              <div v-if="coursewareQAShowAnswer">
                <div
                  v-for="(item, index) in coursewareQACur.answerList"
                  :key="item"
                >
                  {{ item }}
                </div>
                <!-- {{coursewareQACur.answer}} -->
              </div>
              <div v-if="!coursewareQAShowAnswer">点击“答”显示答案</div>
              <!-- {{
                coursewareQAShowAnswer
                  ? coursewareQACur.answer
                  : '点击“答”显示答案'
              }} -->
              <div class="QA-a-arr"></div>
            </div>
            <div
              v-if="coursewareQACur.question_type == '选择题'"
              class="QA-a-list"
            >
              <div
                v-for="(item, index) in coursewareQACur.options"
                :key="item"
                :class="{
                  'QA-a-item': true,
                  'QA-a-item-right':
                    coursewareQAShowAnswer &&
                    coursewareQACur.answer - 1 == index,
                }"
              >
                <!-- 2024.09.11 去除对号 -->
                <!-- <img
                  v-if="
                    coursewareQAShowAnswer &&
                    coursewareQACur.answer - 1 == index
                  "
                  class="QA-a-item-right-icon"
                  src="../../images/courseware-right.png"
                  mode=""
                /> -->
                <!-- 2024.09.11 去除对号 -->
                {{ item }}
              </div>
              <!-- <div class="QA-a-item">选项2</div>
              <div class="QA-a-item">选项3</div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="full-btns">
        <img
          @click="back()"
          class="full-btn"
          src="../../images/back.png"
          alt=""
          srcset=""
        />
        <img
          @click="left()"
          class="full-btn"
          src="../../images/left.png"
          alt=""
          srcset=""
        />
        <img
          @click="right()"
          class="full-btn"
          src="../../images/right.png"
          alt=""
          srcset=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { webType } from '../../const'
import { ossPut2, ossOrigin, ossType } from '@/utils/oss'
import {
  // 首页
  getGrade,
  course_by_teacher,
  collect_course,
  // 提问
  question_list,
  reply_question,
  // 教学日志
  courseware_log_list,
  courseware_list,
  courseware_log,
  courseware_log_del,
  // 期末评价
  evaluate_list,
  evaluate,
  upload,
  evaluate_delete,
  // 上课
  attend_classes,
} from '@/api/teacher.js'

export default {
  name: 'Teach',
  data: () => ({
    webType,

    loading: false,
    pageType: 1, // 1主页 2教学日志 3期末评价 4提问管理 5上课列表 6全屏上课
    gradeData: {}, // 年级

    // 主页
    searchCourseId: '', // 搜索课程id
    searchCourseName: '', // 搜索课程标题
    courseData: [], // 课程列表
    courseTotal: 0, // 课程总数
    coursePage: 1, // 课程分页

    curCourseInfo: {}, // 选中课程
    form: {},

    // 教学日志
    recordData: [], // 教学日志列表
    recordTotal: 0, // 教学日志总数
    recordPage: 1, // 教学日志分页
    recordDetail: false, // 显示教学日志详情
    recordCourseware: [], // 教学日志课件

    // 期末评价
    evaluateData: [], // 期末评价列表
    evaluateTotal: 0, // 期末评价总数
    evaluatePage: 1, // 期末评价分页
    evaluateDetail: false, // 显示期末评价详情
    evaluateImgFiles: [], // 图片列表
    evaluateImgDelectIndex: -1, // 图片选择位置
    evaluateVideoFiles: [], // 视频列表
    evaluateVideoDelectIndex: -1, // 视频选择位置

    // 提问管理
    questionCoursewareName: '', // 提问课件标题
    questionStatus: '', // 提问状态
    questionsData: [], // 提问列表
    questionsTotal: 0, // 提问总数
    questionsPage: 1, // 提问分页
    questionsDetail: false, // 显示提问详情
    questionsEdit: false, // 提问是否为编辑

    // 上课
    courseInfo: {}, // 课程信息
    courseware: [], // 课件
    coursewareQAlist: [], // 题目列表
    coursewareQAIndex: 0, // 题目当前位置
    coursewareQACur: {}, // 当前题目
    coursewareQAShowAnswer: false, // 显示正确答案
  }),
  async mounted() {
    ;(function () {
      var baseFontSize = function () {
        var screenWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth
        // console.log('screenWidth', screenWidth)
        var dWidth = document.documentElement.clientWidth / 80
        // console.log('fontSize', dWidth + 'px')
        dWidth = (dWidth / 2 / 1280) * screenWidth
        if (dWidth < 5) {
          document.documentElement.style.fontSize = '5px'
        } else if (dWidth > 10) {
          document.documentElement.style.fontSize = '10px'
        } else {
          document.documentElement.style.fontSize = dWidth + 'px'
        }
      }
      window.addEventListener('resize', baseFontSize)
      baseFontSize()
    })()

    let gradeRes = await getGrade()
    this.gradeData = gradeRes.data.data

    this.search()
  },
  methods: {
    pageChange(e) {
      console.log('pageChange', e)
      switch (this.pageType) {
        case 1:
          this.coursePage = e
          break
        case 2:
          this.recordPage = e
          break
        case 3:
          this.evaluatePage = e
          break
        case 4:
          this.questionsPage = e
          break
      }
      // this.coursePage = e
      this.search()
    },
    search() {
      this.loading = true
      // pageType: 1, // 1主页 2教学日志 3期末评价 4提问管理 5上课列表 6全屏上课
      if (this.pageType == 1) {
        let data = {
          course_id: this.searchCourseId,
          course_name: this.searchCourseName,
          page: this.coursePage,
          on_shelf: 1,
        }
        course_by_teacher(data).then((res) => {
          this.courseData = res.data.data.list
          this.courseTotal = res.data.data.total
          this.loading = false
        })
      }
      if (this.pageType == 2) {
        courseware_log_list({
          course_id: this.curCourseInfo.id,
          page: this.recordPage,
        }).then((res) => {
          this.recordData = res.data.data.list
          this.recordTotal = res.data.data.total
          this.loading = false
        })
      }
      if (this.pageType == 3) {
        evaluate_list({
          course_id: this.curCourseInfo.id,
          page: this.evaluatePage,
        }).then((res) => {
          this.evaluateData = res.data.data.list
          this.evaluateTotal = res.data.data.total
          this.loading = false
        })
      }
      if (this.pageType == 4) {
        let data = {
          course_id: this.curCourseInfo.id,
          page: this.questionsPage,
          courseware_title: this.questionCoursewareName,
        }
        if (this.questionStatus != '') {
          data.is_reply = this.questionStatus == 1 ? 1 : 0
        }
        question_list(data).then((res) => {
          console.log('question_list', res)
          this.questionsData = res.data.data.list
          console.log('this.questionsData', this.questionsData)
          this.questionsTotal = res.data.data.total
          this.loading = false
        })
      }
    },

    async collectCourse(item) {
      await collect_course({ course_id: item.id })
      this.search()
    },

    // 提问
    // 提问
    // 提问
    toQuestions(item) {
      // console.log('toQuestions', id)
      this.pageType = 4
      this.curCourseInfo = item
      // question_list({ course_id: item.id, is_reply: 0 }).then((res) => {
      //   console.log('question_list', res)
      //   this.questionsData = res.data.data.list
      // })
      this.search()
    },
    toShowQuestionDetail(item) {
      console.log('toShowQuestionDetail', item)
      this.questionsEdit = !!item.reply
      this.questionsDetail = true
      this.form = item
    },
    submitQuestion() {
      console.log('form', this.form)
      reply_question(this.form).then((res) => {
        console.log('reply_question', res)
        let msg = '回复成功'
        if (this.questionsEdit) {
          msg = '修改成功'
        }
        this.$message({
          message: msg,
          type: 'success',
        })
        this.questionsDetail = false
        this.search()
      })
    },

    // 教学日志
    // 教学日志
    // 教学日志
    async toRecord(item) {
      this.pageType = 2
      this.curCourseInfo = item
      let coursewareData = await courseware_list({ course_id: item.id })
      // console.log('coursewareData', coursewareData)
      this.recordCourseware = coursewareData.data.data.list
      this.search()
    },
    addRecord() {
      this.form = {}
      this.recordDetail = true
    },
    editRecord(item) {
      this.form = item
      this.recordDetail = true
    },
    deleteRecord(item) {
      this.$confirm('删除后不可回复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // console.log('this.recordTotal', this.recordTotal - 1)
        // console.log('this.recordPage*20', (this.recordPage - 1) * 20)
        // return
        courseware_log_del({ id: item.id }).then((res) => {
          console.log('courseware_log_del', res)
          this.$message({
            type: 'success',
            message: '删除成功!',
          })
          if (this.recordTotal - 1 == (this.recordPage - 1) * 20) {
            console.log('最后一页')
            this.recordPage = 1
          }
          console.log('this.recordPage', this.recordPage)
          this.search()
        })
      })
    },
    submitRecord() {
      // console.log('form', this.form)
      courseware_log(this.form).then(() => {
        let msg = '新建成功'
        if (this.form.id) {
          msg = '修改成功'
        }
        this.$message({
          message: msg,
          type: 'success',
        })
        this.recordDetail = false
        this.search()
      })
    },

    // 期末测评
    // 期末测评
    // 期末测评
    toEvaluate(item) {
      this.pageType = 3
      this.curCourseInfo = item
      this.search()
    },
    eleteEvaluate(item) {
      this.$confirm('删除后不可回复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // console.log('this.recordTotal', this.recordTotal - 1)
        // console.log('this.recordPage*20', (this.recordPage - 1) * 20)
        // return
        evaluate_delete({ evaluate_id: item.id }).then((res) => {
          console.log('evaluate_delete', res)
          this.$message({
            type: 'success',
            message: '删除成功!',
          })
          if (this.evaluateTotal - 1 == (this.evaluatePage - 1) * 20) {
            console.log('最后一页')
            this.evaluatePage = 1
          }
          this.search()
        })
      })
    },
    addEvaluate() {
      this.form = {}
      this.evaluateImgFiles = []
      this.evaluateVideoFiles = []
      this.evaluateDetail = true
      this.$refs.upload1.value = null
      this.$refs.upload2.value = null
    },
    editEvaluate(item) {
      console.log('item', item)
      this.form = item
      let evaluateImgFiles = []
      // let images = JSON.parse(item.images) || []
      let images = item.images || []
      // images = [
      //   'https://file.mashu.cloud/xiaofenghuang/album/cover/166174467072022823agztsS11318318.jpg',
      //   'https://file.mashu.cloud/xiaofenghuang/banner/1671936686556agztsS12750350.jpg',
      //   'https://file.mashu.cloud/xiaofenghuang/album/cover/166174467072022823agztsS11318318.jpg',
      //   'https://file.mashu.cloud/xiaofenghuang/banner/1671936686556agztsS12750350.jpg',
      //   'https://file.mashu.cloud/xiaofenghuang/album/cover/166174467072022823agztsS11318318.jpg',
      //   'https://file.mashu.cloud/xiaofenghuang/banner/1671936686556agztsS12750350.jpg',
      //   'https://file.mashu.cloud/xiaofenghuang/banner/1671936686556agztsS12750350.jpg',
      //   'https://file.mashu.cloud/xiaofenghuang/album/cover/166174467072022823agztsS11318318.jpg',
      //   'https://file.mashu.cloud/xiaofenghuang/banner/1671936686556agztsS12750350.jpg',
      //   'https://file.mashu.cloud/xiaofenghuang/banner/1671936686556agztsS12750350.jpg',
      // ]
      for (let i = 0; i < images.length; i++) {
        let file = {
          id: i,
          hasUrl: true,
          url: images[i],
          name: images[i],
        }
        evaluateImgFiles.push(file)
      }
      let evaluateVideoFiles = []
      // let videos = JSON.parse(item.videos) || []
      let videos = item.videos || []
      // videos = [
      //   'https://file.mashu.cloud/xiaofenghuang/manageMaterial/video/16611520993671zgnhss.mp4',
      //   'https://file.mashu.cloud/xiaofenghuang/manageMaterial/video/16611520993671zgnhss.mp4',
      //   'https://file.mashu.cloud/xiaofenghuang/manageMaterial/video/16611520993671zgnhss.mp4',
      //   'https://file.mashu.cloud/xiaofenghuang/manageMaterial/video/16611520993671zgnhss.mp4',
      // ]
      for (let i = 0; i < videos.length; i++) {
        let file = {
          id: i,
          hasUrl: true,
          url: videos[i],
          name: videos[i],
        }
        evaluateVideoFiles.push(file)
      }
      this.evaluateImgFiles = evaluateImgFiles
      this.evaluateVideoFiles = evaluateVideoFiles
      this.evaluateDetail = true
      console.log('evaluateImgFiles', this.evaluateImgFiles)
    },
    uploadImgsNew(e) {
      // console.log('uploadImgsNew', e)
      let file = e.target.files[0]
      if (file.size > 10 * 1024 * 1024) {
        this.$refs.upload1.value = null
        this.$message({
          message: '请上传10M以内的图片!',
          type: 'warning',
        })
        return
      }
      if (
        file.name.split('.')[1] !== 'png' &&
        file.name.split('.')[1] !== 'PNG' &&
        file.name.split('.')[1] !== 'jpg' &&
        file.name.split('.')[1] !== 'JPG' &&
        file.name.split('.')[1] !== 'jpeg' &&
        file.name.split('.')[1] !== 'JPEG'
      ) {
        this.$message({
          message: '请上传JPG、PNG格式图片!',
          type: 'warning',
        })
        return
      }
      var _URL = window.URL || window.webkitURL
      this.evaluateImgFiles.push({
        type: 'image',
        url: _URL.createObjectURL(file),
        file: file,
      })
    },
    uploadImgs(res, file) {
      // console.log('res', res)
      console.log('file', file)
      this.evaluateImgFiles.push(file)
    },
    selectImg(index) {
      this.evaluateImgDelectIndex = index
    },
    delectImg(index) {
      let evaluateImgFiles = [...this.evaluateImgFiles]
      evaluateImgFiles.splice(index, 1)
      this.evaluateImgFiles = evaluateImgFiles
      this.$refs.upload1.value = null
    },
    removeImgs(res, file) {
      this.evaluateImgFiles = file
    },
    uploadVideosNew(e) {
      let file = e.target.files[0]
      // console.log('file', file)
      if (file.size > 200 * 1024 * 1024) {
        this.$refs.upload2.value = null
        this.$message({
          message: '请上传200M以内的视频文件!',
          type: 'warning',
        })
        return
      }
      if (
        file.name.split('.')[1] !== 'mp4' &&
        file.name.split('.')[1] !== 'MP4'
      ) {
        this.$message({
          message: '请上传MP4格式视频!',
          type: 'warning',
        })
        return
      }
      var _URL = window.URL || window.webkitURL
      this.evaluateVideoFiles.push({
        type: 'video',
        url: _URL.createObjectURL(file),
        file: file,
      })
    },
    uploadVideos(res, file) {
      this.evaluateVideoFiles.push(file)
    },
    selectVideo(index) {
      this.evaluateVideoDelectIndex = index
    },
    delectVideo(index) {
      let evaluateVideoFiles = [...this.evaluateVideoFiles]
      evaluateVideoFiles.splice(index, 1)
      this.evaluateVideoFiles = evaluateVideoFiles
      this.$refs.upload2.value = null
    },
    removeVideos(res, file) {
      this.evaluateVideoFiles = file
    },
    async submitEvaluate() {
      const loading = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      })
      console.log('form', this.form)
      let data = { ...this.form }
      data.course_id = this.curCourseInfo.id
      let images = []
      for (let i = 0; i < this.evaluateImgFiles.length; i++) {
        let uploadFile = this.evaluateImgFiles[i]
        console.log('uploadFile', uploadFile)
        if (uploadFile.hasUrl) {
          images.push(uploadFile.url)
        } else {
          let fileRes = await ossPut2(
            `${ossType}/teacher/${Math.round(new Date())}.${
              uploadFile.file.name.split('.')[1]
            }`,
            uploadFile.file
          )
          let url = ossOrigin + fileRes.name
          // let formData = new FormData()
          // // formData.append('file', this.evaluateImgFiles[i].raw)
          // formData.append('file', this.evaluateImgFiles[i].file)
          // let urlInfo = await upload(formData)
          // console.log('urlInfo', urlInfo)
          // let url =
          //   'https://meiyukc.oss-cn-shenzhen.aliyuncs.com/' +
          //   urlInfo.data.data.path
          images.push(url)
        }
      }
      console.log('images', images)
      let video = []
      for (let i = 0; i < this.evaluateVideoFiles.length; i++) {
        let uploadFile = this.evaluateVideoFiles[i]
        console.log('uploadFile', uploadFile)
        if (uploadFile.hasUrl) {
          video.push(uploadFile.url)
        } else {
          let fileRes = await ossPut2(
            `${ossType}/teacher/${Math.round(new Date())}.${
              uploadFile.file.name.split('.')[1]
            }`,
            uploadFile.file
          )
          let url = ossOrigin + fileRes.name
          // let formData = new FormData()
          // // formData.append('file', this.evaluateVideoFiles[i].raw)
          // formData.append('file', this.evaluateVideoFiles[i].file)
          // let urlInfo = await upload(formData)
          // console.log('urlInfo', urlInfo)
          // let url =
          //   'https://meiyukc.oss-cn-shenzhen.aliyuncs.com/' +
          //   urlInfo.data.data.path
          video.push(url)
        }
      }
      data.images = images
      data.videos = video
      console.log('data', data)
      // return
      evaluate(data).then(() => {
        loading.close()
        let msg = '新建成功'
        if (this.form.id) {
          msg = '修改成功'
        }
        this.$message({
          message: msg,
          type: 'success',
        })
        this.evaluateDetail = false
        this.search()
      })
    },

    // 上课
    // 上课
    // 上课
    toClass(item) {
      this.pageType = 5
      console.log('item', item)
      let courseInfo = { ...item }
      attend_classes({ course_id: item.id }).then((res) => {
        console.log('attend_classes', res)
        let coursewareNum = 0
        let courseware = res.data.data
        for (let i = 0; i < courseware.length; i++) {
          coursewareNum = coursewareNum + courseware[i].courseware.length
        }
        courseInfo.classHourNum = courseware.length
        courseInfo.coursewareNum = coursewareNum
        this.courseware = courseware
        this.courseInfo = courseInfo
      })
    },
    goBack() {
      this.pageType = 1
      this.search()
    },

    toCourseware(i) {
      console.log('i', i)
      this.pageType = 6
      let coursewareList = [...i.content]
      for (let i = 0; i < coursewareList.length; i++) {
        // type 1视频 2问答 3选择
        coursewareList[i].question_type = ['', '视频', '问答题', '选择题'][
          coursewareList[i].type
        ]
        coursewareList[i].video_url = coursewareList[i].content.url
        coursewareList[i].question = coursewareList[i].content.question
        coursewareList[i].answer = coursewareList[i].content.answer
        if (coursewareList[i].type == 3) {
          let random = parseInt(Math.random() * 3)
          coursewareList[i].answer = random + 1
          console.log('random', random)
          if (random == 0) {
            coursewareList[i].options = [
              coursewareList[i].content.answer,
              coursewareList[i].content.option1,
              coursewareList[i].content.option2,
            ]
          }
          if (random == 1) {
            coursewareList[i].options = [
              coursewareList[i].content.option1,
              coursewareList[i].content.answer,
              coursewareList[i].content.option2,
            ]
          }
          if (random == 2) {
            coursewareList[i].options = [
              coursewareList[i].content.option1,
              coursewareList[i].content.option2,
              coursewareList[i].content.answer,
            ]
          }
        }
      }
      console.log('coursewareList', coursewareList)
      this.coursewareQAlist = coursewareList
      // this.coursewareQAlist = i.content
      this.coursewareQAIndex = 0
      this.playCourseware()
    },
    back() {
      this.pageType = 5
    },
    left() {
      let coursewareQAIndex = this.coursewareQAIndex
      if (coursewareQAIndex == 0) {
        this.$message({
          message: '第一个了！',
          type: 'warning',
        })
        return
      }
      this.coursewareQAIndex = coursewareQAIndex - 1
      this.playCourseware()
    },
    right() {
      let coursewareQAIndex = this.coursewareQAIndex
      let length = this.coursewareQAlist.length
      if (coursewareQAIndex == length - 1) {
        this.$message({
          message: '最后一个了！',
          type: 'warning',
        })
        return
      }
      this.coursewareQAIndex = coursewareQAIndex + 1
      this.playCourseware()
    },
    playCourseware() {
      this.coursewareQAShowAnswer = false
      this.coursewareQACur = this.coursewareQAlist[this.coursewareQAIndex]
      this.coursewareQACur.answerList =
        this.coursewareQAlist[this.coursewareQAIndex].answer.split('\n')
    },
    toShowAnswer() {
      this.coursewareQAShowAnswer = true
    },
  },
}
</script>

<style lang="less">
// @media (min-width: 640px) {
//   font-size: 5px;
// }
// @media (min-width: 1200px) {
//   font-size: 10px;
// }
html {
  font-size: 10px;
}
.teach {
  .question-reply {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .hidden-input {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
  }
  .el-textarea__inner {
    min-height: 120px !important;
  }
  .file-list {
    display: flex;
    flex-flow: row wrap;
    margin-top: 20px;
    .file-item {
      position: relative;
      width: 150px;
      height: 100px;
      margin: 0 10px 10px;
      .file-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 150px;
        height: 100px;
        background-color: rgba(0, 0, 0, 0.5);
      }
      .file-delete {
        position: absolute;
        top: 30px;
        right: 55px;
        font-size: 40px;
        color: #fff;
      }
      .file {
        width: 150px;
        height: 100px;
      }
    }
  }
  .full {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    min-width: 120rem;
    height: calc(100vh - 70px);
    padding: 1rem;
    background-image: url('https://file.mashu.cloud/qlxhj/meiyukecheng/coursewareBg.png');
    background-size: 100% 100%;
    background-color: #fff;
    box-sizing: border-box;
    .QA-bg {
      width: calc(100vw - 2rem);
      min-width: 118rem;
      height: calc(100vh - 70px - 2rem);
      padding-top: 3.5rem;
      // background-color: #6a6ab5;
      box-sizing: border-box;
      overflow-x: auto;
      .QA-content {
        width: calc(100vw - 7rem);
        min-width: 113rem;
        height: calc(100vh - 70px - 8rem);
        margin: 0 auto;
        border-radius: 3rem;
        background-color: #fdf5d1;
        overflow: auto;
        .QA-q {
          padding: 5.9rem 5rem 4.9rem;
          font-size: 4.4rem;
          color: #774726;
          line-height: 6.4rem;
          text-align: center;
        }
        .QA-a {
          display: flex;
          justify-content: center;
          padding-bottom: 3rem;
          .QA-a-icon {
            width: 15rem;
            height: 14.6rem;
          }
          .QA-a-list {
            margin-left: 2.5rem;
            .QA-a-item {
              position: relative;
              width: 86rem;
              height: 9rem;
              margin-bottom: 2rem;
              font-size: 3.4rem;
              color: #774726;
              line-height: 9rem;
              text-align: center;
              background: #f1e7bc;
              border-radius: 3rem;
              .QA-a-item-right-icon {
                position: absolute;
                top: 2.1rem;
                right: 4rem;
                width: 5rem;
                height: 4.8rem;
              }
            }
            .QA-a-item-right {
              background: rgba(252, 73, 36, 0.14);
            }
          }
          .QA-a-content {
            position: relative;
            width: 86rem;
            height: 26rem;
            margin-left: 2.5rem;
            padding: 2.3rem 3rem;
            font-size: 3.4rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: rgba(#774726, 0.7);
            line-height: 4.8rem;
            background: #f1e7bc;
            border-radius: 3rem;
            box-sizing: border-box;
            .QA-a-arr {
              position: absolute;
              top: 5rem;
              left: -6rem;
              width: 2rem;
              height: 0;
              border: 2rem solid #fff;
              border-top-color: transparent;
              border-left-color: transparent;
              border-bottom-color: transparent;
              border-right-color: #f1e7bc;
            }
          }
        }
      }
    }
    .video {
      width: calc(100vw - 2rem);
      height: calc(100vh - 70px - 2rem);
    }
    .full-btns {
      display: flex;
      align-items: center;
      position: absolute;
      right: 5rem;
      bottom: 8rem;
      .full-btn {
        width: 7rem;
        height: 7rem;
        margin-left: 2rem;
      }
    }
  }
  .phone {
    margin-top: 20px;
    margin-left: 80px;
    width: 37.5rem;
    height: calc(100vh - 70px - 13rem);
    background-color: #efefef;
    border-radius: 2rem;
    box-shadow: 0 0.2rem 2rem 0 #ccc;
    overflow: hidden;
    box-sizing: border-box;
    .course-info {
      display: flex;
      align-items: center;
      justify-content: center;
      // height: 100px;
      width: 37.5rem;
      padding: 2rem 0;
      background-color: #fff;
      box-sizing: border-box;
      .course-avatar {
        width: 17rem;
        height: 9.5rem;
        margin-right: 2rem;
        border-radius: 0.5rem;
        background-color: #efefef;
      }
      .course-name {
        width: 16.2rem;
        font-size: 1.8rem;
        font-weight: bold;
        color: #1a1a1a;
        line-height: 2rem;
      }
      .course-grade {
        margin: 0.5rem 0;
        font-size: 1.6rem;
        font-weight: bold;
        color: #1a1a1a;
        line-height: 2rem;
      }
      .course-num {
        font-size: 1.6rem;
        color: #1a1a1a;
        line-height: 2rem;
      }
    }
    .course-list::-webkit-scrollbar {
      display: none;
    }
    .course-list {
      width: 34.5rem;
      min-height: 30rem;
      max-height: calc(100vh - 70px - 29rem);
      margin: 1rem auto;
      padding-bottom: 2rem;
      background-color: #fff;
      border-radius: 15px;
      overflow-y: auto;
      overflow-x: hidden;
      .course-catalogue {
        height: 4rem;
        padding-left: 1rem;
        font-size: 1.6rem;
        color: #1a1a1a;
        line-height: 4rem;
      }
      .course-title {
        width: 32.5rem;
        margin: 0 auto;
        padding: 1rem;
        font-size: 1.8rem;
        font-weight: bold;
        color: #1a1a1a;
        line-height: 2rem;
        border-top: 0.2rem solid #f4f4f4;
      }
      .course-courseware {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 34.5rem;
        min-height: 4rem;
        padding: 0.5rem 1rem 0.5rem 3rem;
        color: #424242;
        box-sizing: border-box;
        .course-courseware-name {
          width: 22rem;
        }
      }
    }
  }
}
</style>
